import React from 'react';

import { JourneySequenceBar } from '@/components/modules/journey/sequence-bar';
import { SequenceItem } from '@/components/modules/option/bar-sequence/utils';

export interface OptionBarSequenceProps {
  sequenceItems: SequenceItem[];
  ratio?: number;
}

const OptionBarSequence = ({ sequenceItems, ratio = 1 }: OptionBarSequenceProps) => {
  return (
    <div className="flex" style={{ width: `${ratio * 100}%` }}>
      {sequenceItems.map((sequenceItem) => {
        return <JourneySequenceBar key={sequenceItem.id} {...sequenceItem} />;
      })}
    </div>
  );
};

export { OptionBarSequence };
